import InfoIcon from '@clearkit/icons/glyphs/InfoHollow';
import { CKTooltip } from '@clearkit/react';

export default function InfoTooltip({ title, ...props }) {
  return (
    <CKTooltip
      tooltip={<p className="font-normal">{title}</p>}
      arrowPlacement="bottom"
      options={{ placement: 'top' }}
      {...props}>
      <div className="ml-2 text-gray-600 outline-none">
        <InfoIcon width="16" height="16" />
      </div>
    </CKTooltip>
  );
}

InfoTooltip.defaultProps = {
  unstable_portal: 'true',
};

InfoTooltip.propTypes = {
  title: PropTypes.string.isRequired,
  unstable_portal: PropTypes.bool,
};
